import s from "./UserInfoHeader.module.scss"

export const UserInfoHeaderSkeleton = () => {
  return (
    <div className={s.skeleton}>
      <div className={s.skeleton__completed} />
      <div className={s.skeleton__stars} />
      <div className={s.skeleton__mandatory} />
    </div>
  )
}
